import React, { useState, useEffect } from "react";
import { Modal, Button, Tabs, Tab } from "react-bootstrap";
import { Calendar, Clock, BookOpen, X } from "lucide-react";
import RecipeView from "./RecipeView";
import "bootstrap/dist/css/bootstrap.min.css";

const MEAL_TYPE_BY_ID = {
    1: "Frühstück",
    2: "Mittagessen",
    3: "Abendessen",
    4: "Snack/Anderes",
};

const RecipeDetailDialog = ({
    show,
    onClose,
    initialData, // Can be a Plan object or a Recipe object
    allRecipes = [],
    onPlan, // Callback when user wants to plan this recipe (e.g. from mobile)
    showShoppingListAction = false
}) => {
    // Resolve which recipe we are showing
    const displayedRecipe = React.useMemo(() => {
        if (initialData?.recipe) return initialData.recipe; // If passed as Plan with populated recipe
        if (initialData?.id && !initialData.planDate) return initialData; // If passed as Recipe object (no planDate)
        if (initialData?.recipeId) return allRecipes.find(r => r.id === initialData.recipeId);
        return null;
    }, [initialData, allRecipes]);

    return (
        <Modal show={show} onHide={onClose} fullscreen="md-down" size="xl" scrollable centered>
            <Modal.Header closeButton className="border-0 pb-0">
                {/* Optional: Title or Actions here if needed, but closeButton is enough mostly */}
            </Modal.Header>
            <Modal.Body className="p-0 bg-light">
                {displayedRecipe ? (
                    <div className="bg-white min-vh-100">
                        <RecipeView
                            recipe={displayedRecipe}
                            onBack={onClose}
                            onPlan={!initialData?.planDate ? () => onPlan && onPlan(displayedRecipe) : undefined}
                            showShoppingListAction={showShoppingListAction}
                        />
                    </div>
                ) : (
                    <div className="d-flex flex-column align-items-center justify-content-center h-100 text-muted p-5">
                        <BookOpen size={48} className="mb-3 opacity-25" />
                        <h5>Kein Rezept verknüpft</h5>
                        <p>Diesem Eintrag ist kein Rezept hinterlegt.</p>
                        <Button variant="light mt-3" onClick={onClose}>Schließen</Button>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default RecipeDetailDialog;
